import { render, staticRenderFns } from "./JournalForm.vue?vue&type=template&id=266182ce"
import script from "./JournalForm.vue?vue&type=script&lang=js"
export * from "./JournalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports